import React from 'react';

import PropTypes from 'prop-types';
import Box from '@tds/core-box';
import Heading from '@tds/core-heading';
import Strong from '@tds/core-strong';

import {
  Thead,
  Td,
  Tr,
  Th
} from '../orderDetailsSection/ratePlans/components/css';
import getFormattedPricing from '../orderDetailsSection/utils';

const SummaryAddons = ({ addons, total }) => {
  return (
    <>
      {Object.keys(addons).length === 0 && <h4>No addons Selected</h4>}
      {Object.keys(addons).length > 0 && (
        <Box between={3}>
          <Heading level="h4">Add-ons</Heading>
          <table>
            <Thead>
              <Tr>
                <Th>Add-on</Th>
                <Th>Unit</Th>
                <Th>Unit Price</Th>
                <Th>Total</Th>
              </Tr>
            </Thead>
            <tbody>
              {Object.keys(addons).map(addonName => {
                const { quantity, unitPrice } = addons[addonName];
                return (
                  <tr>
                    <Td style={{ background: '#f7f7f7', fontWeight: '700' }}>
                      {addonName}
                    </Td>
                    <Td>{quantity}</Td>
                    <Td>{getFormattedPricing(unitPrice)}</Td>
                    <Td>{getFormattedPricing(unitPrice * quantity)}</Td>
                  </tr>
                );
              })}
              <Tr style={{ background: '#f4f4f4' }}>
                <Td colSpan={3}>
                  <Strong>Total</Strong>
                </Td>
                <Td>
                  <Strong>{getFormattedPricing(total)}</Strong>
                </Td>
              </Tr>
            </tbody>
          </table>
        </Box>
      )}
    </>
  );
};

SummaryAddons.propTypes = {
  addons: PropTypes.objectOf(PropTypes.any).isRequired,
  total: PropTypes.number.isRequired
};

export default SummaryAddons;
